import { TStatus } from 'apps/booking/components/Booking/IssueStateSidebar/types'
import { TIssueState } from 'constants/issueStatus'

export const SELECT_ISSUE_STATE = 'SELECT_ISSUE_STATE'

export interface ISelectIssueState {
  issueState: TIssueState
  status: TStatus
}

export const selectIssueState = ({ issueState, status }: ISelectIssueState) => {
  return {
    type: SELECT_ISSUE_STATE,
    payload: {
      issueState,
      status,
    },
  }
}
